import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class StringHelperService {
	truncate(value: string, limit: number): string {
		if (value.length > limit) {
			const NUM_ELLIPSIS = 3;
			value = value.trim().split('').slice(0, (limit - NUM_ELLIPSIS)).join('');
			value += '...';
		}

		return value;
	}
}
